import {Company, companyDecoder} from './Company'
import {Decoder, object, field, number} from 'json-bouncer'
import {Inquiry, inquiryDecoder} from './Inquiry'

export interface InquiryForList {
    readonly inquiry: Inquiry
    readonly company: Company
    readonly currentOffer: number
}

export function decoder(): Decoder<InquiryForList> {
    return object({
        inquiry: field('inquiry', inquiryDecoder()),
        company: field('company', companyDecoder()),
        currentOffer: field('currentOffer', number())
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryForList.ts